import React, { PureComponent } from 'react';
import CheckIcon from 'mdi-react/CheckIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';

class CheckBoxField extends PureComponent {
  componentDidMount() {
    this.props.onChange(this.props.defaultChecked);
  }

  render() {
    const {
      disabled,
      value,
      color,
      name,
      label = '',
      labelBefore = '',
      className,
      onChange,
      touched,
      error
    } = this.props;

    return (
      <div>
        <label
          className={classnames('checkbox-btn', className, {
            disabled: disabled,
            checked: value
          })}
        >
          {labelBefore && (
            <span
              className="checkbox-btn__label-before"
              dangerouslySetInnerHTML={{ __html: labelBefore }}
            />
          )}
          <input
            className="checkbox-btn__checkbox"
            type="checkbox"
            name={name}
            onChange={onChange}
            checked={value}
            disabled={disabled}
          />
          <span
            className={classnames('checkbox-btn__checkbox-custom', {
              after: labelBefore
            })}
            style={color ? { background: color, borderColor: color } : {}}
          >
            <CheckIcon />
          </span>
          {className === 'button' ? (
            <span className="checkbox-btn__label-svg">
              <CheckIcon className="checkbox-btn__label-check" />
              <CloseIcon className="checkbox-btn__label-uncheck" />
            </span>
          ) : (
            ''
          )}
          {label && (
            <span
              className="checkbox-btn__label"
              dangerouslySetInnerHTML={{ __html: label }}
            />
          )}
          <div id="auto-country" className="info-tooltip">
            ?
          </div>
          <UncontrolledTooltip
            placement="right"
            target="auto-country"
            className="info-tooltip"
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </UncontrolledTooltip>
        </label>
        {touched &&
          error && <span className="form__form-group-error">{error}</span>}
      </div>
    );
  }
}

const renderCheckBoxField = props => (
  <CheckBoxField
    {...props.input}
    {...props.meta}
    label={props.label}
    defaultChecked={props.defaultChecked}
    disabled={props.disabled}
    labelBefore={props.labelBefore}
    className={props.className}
    color={props.color}
  />
);

renderCheckBoxField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  labelBefore: PropTypes.string,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.string
};

export default renderCheckBoxField;



// WEBPACK FOOTER //
// ./src/components/formFields/CheckBox.js